import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-label-title-subtitle',
  templateUrl: './label-title-subtitle.component.html',
  styleUrls: ['./label-title-subtitle.component.scss']
})
export class LabelTitleSubtitleComponent extends ComponentBase implements OnInit {

  constructor() { super()}

  ngOnInit() {
  }
}
